import { UserProfileGateway } from '../user-management/gateways/user-profile-gateway'
import { FieldValidator } from './field-validator'

export class PasswordCorrectCountValidator implements FieldValidator<string> {
    isOldPasswordCorrect: boolean
    FailedLoginAttemptCount: number

    constructor(
        private userProfileGateway: UserProfileGateway,
        private userProfileID: number,
        private username: string,
        private FailedAttemptsAllowed: number
    ) {}

    validate(text: string, fieldName: string): Promise<string> {
        const oldPasswordErrorMsg = 'The password you entered is incorrect. '
        const countErrorMsg = 'You have '
        const lockErroMsg = 'You have exceeded the allowed number of attempts. Your account has been locked.'
        this.isOldPasswordCorrect = this.userProfileGateway.isPasswordCountCorrect(encodeURIComponent(text), this.userProfileID)

        return new Promise((resolve, reject) => {
            if (!this.isOldPasswordCorrect) {
                this.FailedLoginAttemptCount = this.userProfileGateway.getFailedLoginAttempts(this.username, this.FailedAttemptsAllowed)
                if (this.FailedLoginAttemptCount < this.FailedAttemptsAllowed) {
                    reject(oldPasswordErrorMsg /*+ countErrorMsg + (this.FailedAttemptsAllowed - this.FailedLoginAttemptCount) + ' attempts left.'*/)
                } else if (this.FailedLoginAttemptCount >= this.FailedAttemptsAllowed) {
                    this.userProfileGateway.lockUserAccount(this.username)
                    reject(lockErroMsg)
                    setTimeout(() => {
                        window.location.href = '/Auth/Logout.aspx'
                    }, 2000)
                } else {
                    reject(oldPasswordErrorMsg)
                }
            } else {
                resolve('')
            }
        })
    }
}
